<div class="admin-users">
    <div class="page-header">
        <div>
            <h2>Gestion des Utilisateurs</h2>
            <p class="text-muted">Gérez tous les utilisateurs de la plateforme</p>
        </div>
        <!--
        <button class="btn btn-primary" (click)="exportData()">
            <i class="bi bi-download me-2"></i>Exporter 
        </button>
        -->
    </div>

    <!-- Filters -->
    <div class="filters-card">
    <div class="row g-3">
        <div class="col-md-4">
        <div class="search-box">
            <i class="bi bi-search"></i>
            <input type="text" class="form-control" placeholder="Rechercher un utilisateur..." 
                    [(ngModel)]="searchTerm" (ngModelChange)="onSearch()">
        </div>
        </div>
        <div class="col-md-3">
        <select class="form-select" [(ngModel)]="filterType" (ngModelChange)="applyFilters()">
            <option value="">Tous les types</option>
            <option value="standard">Standard</option>
            <option value="pro">Pro</option>
            <option value="admin">Admin</option>
        </select>
        </div>
        <div class="col-md-3">
        <select class="form-select" [(ngModel)]="filterPlan" (ngModelChange)="applyFilters()">
            <option value="">Tous les plans</option>
            <option value="free">Free</option>
            <option value="basic">Basic</option>
            <option value="premium">Premium</option>
        </select>
        </div>
        <div class="col-md-2">
        <button class="btn btn-outline-secondary w-100" (click)="resetFilters()">
            <i class="bi bi-arrow-clockwise me-2"></i>Reset
        </button>
        </div>
    </div>
    </div>

    <!-- Stats -->
    <div class="row g-4 mb-4">
    <div class="col-md-3">
        <div class="stat-card stat-primary">
        <div class="stat-icon"><i class="bi bi-people"></i></div>
        <div class="stat-content">
            <h3>{{ stats.total }}</h3>
            <p>Total Utilisateurs</p>
        </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="stat-card stat-success">
        <div class="stat-icon"><i class="bi bi-person-check"></i></div>
        <div class="stat-content">
            <h3>{{ stats.active }}</h3>
            <p>Actifs</p>
        </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="stat-card stat-warning">
        <div class="stat-icon"><i class="bi bi-briefcase"></i></div>
        <div class="stat-content">
            <h3>{{ stats.pro }}</h3>
            <p>Professionnels</p>
        </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="stat-card stat-info">
        <div class="stat-icon"><i class="bi bi-star"></i></div>
        <div class="stat-content">
            <h3>{{ stats.premium }}</h3>
            <p>Premium</p>
        </div>
        </div>
    </div>
    </div>

    <!-- Table -->
    <div class="table-card">
    <div class="table-responsive">
        <table class="table">
        <thead>
            <tr>
            <!-- <th><input type="checkbox"></th> -->
            <th>Utilisateur</th>
            <th>Type</th>
            <th>Plan</th>
            <th>Sociétés</th>
            <th>Statut</th>
            <th>Inscrit le</th>
            <th>Actions</th>
            </tr>
        </thead>
        <tbody>
            @for(user of filteredUsers; track user._id) {
            <tr>
                <!-- <td><input type="checkbox"></td> -->
                <td>
                <div class="user-cell">
                    <div class="user-avatar">{{ user.firstName.charAt(0) }}{{ user.lastName.charAt(0) }}</div>
                    <div>
                    <div class="user-name">{{ user.firstName }} {{ user.lastName }}</div>
                    <div class="user-email">{{ user.email }}</div>
                    </div>
                </div>
                </td>
                <td>
                <span class="badge" [class.badge-primary]="user.userType === 'admin'"
                        [class.badge-info]="user.userType === 'pro'"
                        [class.badge-secondary]="user.userType === 'standard'">
                    {{ user.userType }}
                </span>
                </td>
                <td>
                <span class="plan-badge" [class.plan-premium]="user.userPlan.planName === 'premium'"
                        [class.plan-basic]="user.userPlan.planName === 'basic'"
                        [class.plan-free]="user.userPlan.planName === 'free'">
                    {{ user.userPlan.planName }}
                </span>
                </td>
                <td>
                <span class="companies-count">{{ user.companies.length }}</span>
                </td>
                <td>
                <span class="status-badge" [class.status-active]="user.isActif" 
                        [class.status-inactive]="!user.isActif">
                    {{ user.isActif ? 'Actif' : 'Suspendu' }}
                </span>
                </td>
                <td><small>{{ user.createdAt | date:'dd/MM/yyyy' }}</small></td>
                <td>
                <div class="action-buttons">
                    <!--
                    <button class="btn-action btn-view" (click)="viewUser(user)">
                    <i class="bi bi-eye"></i>
                    </button>
                    <button class="btn-action btn-edit" (click)="editUser(user)">
                    <i class="bi bi-pencil"></i>
                    </button>
                    -->
                    <button class="btn-action" 
                            [class.btn-suspend]="user.isActif"
                            [class.btn-activate]="!user.isActif"
                            (click)="toggleUserStatus(user)">
                    <i class="bi" [class.bi-pause]="user.isActif" [class.bi-play]="!user.isActif"></i>
                    </button>
                    <button class="btn-action btn-delete" (click)="deleteUser(user)">
                    <i class="bi bi-trash"></i>
                    </button>
                </div>
                </td>
            </tr>
            } @empty {
            <tr>
                <td colspan="8" class="text-center py-5">
                <i class="bi bi-inbox" style="font-size: 3rem; color: #cbd5e1;"></i>
                <p class="mt-3 text-muted">Aucun utilisateur trouvé</p>
                </td>
            </tr>
            }
        </tbody>
        </table>
    </div>
    </div>
</div>
